package components

import androidx.compose.runtime.*
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.events.EventListener
import shared.config.WebsiteCOs

@Composable
fun Header(
    isDark: Boolean,
    onThemeToggle: () -> Unit,
    onNavigate: (String) -> Unit
) {
    var isScrolled by remember { mutableStateOf(false) }

    DisposableEffect(Unit) {
        val listener = EventListener {
            isScrolled = window.scrollY > 10
        }
        window.addEventListener("scroll", listener, js("({passive: true})"))
        onDispose { window.removeEventListener("scroll", listener) }
    }

    val scrollShadow = if (isScrolled) {
        if (isDark) "0 2px 8px rgba(255, 255, 255, 0.15)"
        else "0 2px 8px rgba(0, 0, 0, 0.15)"
    } else "none"

    Header(attrs = {
        style {
            position(Position.Sticky)
            top(0.px)
            property("padding", "1rem 1.5rem")
            property("z-index", "50")
            property("transition", "box-shadow 0.3s ease")
            property("background-color", "var(--background)")
            property("box-shadow", scrollShadow)
        }
    }) {
        Nav(attrs = {
            style {
                maxWidth(80.cssRem)
                property("margin", "0 auto")
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.SpaceBetween)
            }
        }) {
            // Logo
            A(attrs = {
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    gap(0.75.cssRem)
                    cursor("pointer")
                    property("transition", "all 0.2s ease")
                    textDecoration("none")
                    property("color", "inherit")
                }
                onClick { e ->
                    e.preventDefault()
                    onNavigate("/")
                }
                attr("href", "/")
            }) {
                // Circle "R" logo
                Span(attrs = {
                    style {
                        property("display", "inline-flex")
                        alignItems(AlignItems.Center)
                        justifyContent(JustifyContent.Center)
                        width(2.25.cssRem)
                        height(2.25.cssRem)
                        borderRadius(9999.px)
                        property("background-color", "var(--primary)")
                        property("color", "var(--on-primary)")
                        fontWeight(700)
                        fontSize(1.25.cssRem)
                        flexShrink(0)
                    }
                }) { Text("R") }

                Span(attrs = {
                    style {
                        fontSize(1.5.cssRem)
                        fontWeight(700)
                        property("color", "var(--on-surface)")
                    }
                }) { Text(WebsiteCOs.appName) }
            }

            // Actions (theme switcher)
            Div(attrs = {
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    gap(1.cssRem)
                }
            }) {
                ThemeSwitcher(isDark, onThemeToggle)
            }
        }
    }
}
